class project {
  constructor() {

    window.projectHidden = false;

    if(!window.closeProject) {
      window.closeProject = function(){
        console.log(window.navigating);
        if(!window.preventTitleHovers && !window.navigating) {
          window.navigating = true;
          if($('.clonetitle').length){
            $('.clonetitle').hide();
          }
          $('.end-sticky').css('opacity',1);

          setTimeout(function(){

            gsap.to('.wrap-project', {
              opacity: 0,
              duration: 0.3,
              onComplete: function(){
                setTimeout(function(){
                  $('.wrap-project').hide();
                  window.projectHidden = true;
                  $(window).scrollTop(window.prevScroll||0);

                  setTimeout(function(){
                    $('.end-sticky').removeClass('end-sticky');
                    // $(window).scrollTop(window.prevScroll||0);
                    $(window).scrollTop(window.prevScroll||0);

                    $('.fixed').removeClass('fixed');
                    $(window).scrollTop(window.prevScroll||0);
                    window.noScrollDetect = false;
                    window.navigating = false;
                  }, MOBILE ? 200 : 0);
                }, MOBILE ? 200 : 0);

              }
            });


            $('.project--close').addClass('out');
            $('.menu-button').removeClass('out');

            var hasSafari = $('html').hasClass('safari');

            setTimeout(function(){

              if($('.index--wrap').length>0){
                $('html').attr('class','index');
                window.history.pushState({}, window.sitetitle+' – Index', window.siteurl+'/index');
              } else if($('.home--cols').length>0){
                $('html').attr('class','home');
                $('.menu-button').addClass('noanim');
                $('.home--cols--col--text').show(); // because if clicked they are fadeOuted
                if(window.home && window.home.scene) window.home.scene.run = true;
                window.history.pushState({}, window.sitetitle, window.siteurl);
                window.homegeneral.runNotis();
              } else if($('.home3d--wrap').length>0){
                $('html').attr('class','home3d');
                if(window.home && window.home.scene){
                  $('a.model').removeClass('in');
                  window.home.scene.run = true;
                  window.home.scene.pointer.x = -999;
                  window.home.scene.pointer.y = -999;
                }
                window.history.pushState({}, window.sitetitle, window.siteurl+'/3d');
                window.homegeneral.runNotis();
              } else {
                var cls = $('[data-htmlclass]:not(.wrap-project)').attr('data-htmlclass');
                $('html').attr('class',cls);
                setTimeout(function(){
                  $('html').addClass('ready');
                }, 500);
                if(cls=='studio') {
                  $('.header').addClass('huge');
                  window.history.pushState({}, window.sitetitle+' – Studio', window.siteurl+'/studio');
                }
              }

              if(hasSafari){
                $('html').addClass('safari');
              }

            }, MOBILE ? 300 : 100);
          }, MOBILE ? 20 : 0);
        }
      }
    }

    this.treats();

    // if(window.previousNavFrom){
      // if(window.previousNavFrom!='project' && $('[data-htmlclass]').length){
        // window.previousNavFrom = $('[data-htmlclass]').attr('data-htmlclass');
//
        // if($('.end-sticky').attr('data-htmlclass')=='home') {
          // window.previousNavFrom = 'home';
        // }
//
        // $('a.project--close').attr('href', function(){
          // $(this).attr('href', siteurl+'/'+window.previousNavFrom);
        // });
      // }
    // }

    $('.end-sticky--blur').unbind('click').click(function(e){
      // var st = $(this).attr('style');
      // if(st.indexOf('blur')>=0){
      window.navigating = true;
      var topVal = $('html').get(0).scrollHeight - window.innerHeight;
      gsap.to('.end-sticky--blur', {
        backdropFilter : 'blur(0px)',
        duration: 0.8,
      });
      gsap.to('html', {
        scrollTop: topVal,
        duration: 0.8,
        onComplete: function(){
          window.navigating = false;
          window.closeProject();
          // $('.project--close').click();
          // $(window).scrollTop(window.prevScroll||0);
        }
      });
      // $('html').animate({ 'scrollTop' : topVal }, 800, function(){
      //   setTimeout(function(){
      //     $(window).scrollTop(window.prevScroll);
      //   }, 5);
      // });
      // }
    });

    $('.project--close').unbind('click').click(function(e){
      e.preventDefault();
      window.closeProject();
    });

    clearTimeout(window.notisInTimeout);
    if(window.notisInTimeoutNews){
      for(var n=0;n<window.notisInTimeoutNews.length;n++){
        clearTimeout(window.notisInTimeoutNews[n]);
        window.notisInTimeoutNews[n] = null;
      }
    }
    $('.noti:not(.keksi)').removeClass('in');

    // this.initSlides();

    $('video').unbind('click').click(function(){
      if($(this).siblings('.video--sound').length){
        let willBeMuted = null;
        if(this.muted) {
          this.volume = 0.0;
          this.muted = false;
          willBeMuted = false;
          $(this).animate({'volume' : 1}, 200);
        } else {
          willBeMuted = true;
          $(this).animate({'volume' : 0}, 200, function(){
            this.muted = true;
          });
        }
        // this.muted = !this.muted;

        // mute others
        if(!willBeMuted) {
          $('video').not(this).each(function(){
            $(this).animate({'volume' : 0}, 200, function(){
              this.muted = true;
            });
            $(this).siblings('.video--sound').text('Unmute').removeClass('black');
          });
        }

        $(this).siblings('.video--sound').removeClass('force-out');

        if(willBeMuted) {
          $(this).siblings('.video--sound').text('Unmute').removeClass('black');
        } else {
          $(this).siblings('.video--sound').text('Mute').addClass('black');
        }

        var t = this;

        clearTimeout(this.time);
        this.time = setTimeout(function(){
          $(t).siblings('.video--sound').addClass('force-out');
        }, 900);
      }
    });

    $('.video--wrap').unbind('mousemove mouseleave').mousemove(function(){
      $(this).find('.video--sound').removeClass('force-out');

      clearTimeout(this.time);
      var t = this;
      this.time = setTimeout(function(){
        $(t).find('.video--sound').addClass('force-out');
      }, 900);
    }).mouseleave(function(){
      $(this).find('.video--sound').removeClass('force-out');
    });

    if(!window.projectScrollInited) {
      window.projectScrollInited = true;
      $(window).scroll(function(){
        if($('html').hasClass('project')) {
          if(!window.navigating){
            $('.related--project').each(function(){
              let rect = this.getBoundingClientRect();
              if(rect.top < window.innerHeight) {
                let fromMid = Math.max(0, rect.top - window.innerHeight*.55);
                $(this).children('img').css({
                  'transform' : 'rotate('+fromMid/2+'deg)'
                });
              }
            });

            $('.project--wrap video').each(function(){
              let rect = this.getBoundingClientRect();
              if(rect.top < window.innerWidth && rect.bottom > 0) {
                if(this.paused){
                  this.play();
                  if(!this.muted) {
                    $(this).animate({'volume' : 1}, 200);
                  }
                }
              } else {
                // not in view
                if(!this.paused) {
                  if(!this.muted) {
                    $(this).animate({'volume' : 0}, 200, function(){
                      this.pause();
                    });
                  } else {
                    this.pause();
                  }
                }
              }
            });

            if(!window.projectHidden) {
            // if($('.project--wrap:visible').length>0) {
              var btm = $('.project--wrap').get(0).getBoundingClientRect().bottom;

              if(btm < window.innerHeight * 1.5) {
                if(window.home && window.home.scene){
                  home.scene.run = true;
                }
                // console.log('setting end sticky op to 1');
                $('.end-sticky:not([style*="opacity: 1"])').css('opacity',1); //.show();
              } else if(btm > window.innerHeight*1.5) {
                if(window.home && window.home.scene){
                  home.scene.run = false;
                }
                $('.end-sticky:not([style*="opacity: 0"])').css('opacity',0); //.hide();
              }

              if(btm < window.innerHeight*1.1) {
                var val = 15 * (btm / window.innerHeight);
                val = Math.min(15, Math.max(0, val));

                window.noScrollDetect = true;

                $('.end-sticky--blur').css({
                  'backdrop-filter' : 'blur('+val+'px)',
                  '-webkit-backdrop-filter' : 'blur('+val+'px)',
                  // 'filter' : 'blur('+val+'px)',
                });
              } else {
                window.noScrollDetect = false;
              }

              // remove main project and make end sticky the main
              if(btm <= 0) {
                window.closeProject();
              }
            }
          }
        }
      });
    }

    $('.menu-button').addClass('out');
    setTimeout(function(){
      $('.project--close').removeClass('out');
    }, 500);
  }

  treats() {
    $('.content-block.type-text').prevAll().not('.type-line').first().addClass('last-img-before-type');

    let fit = $('.wrap-project .project--wrap').attr('data-moblast');
    $('.last-img-before-type').addClass('lastfit-'+fit);

    $('.content-block figcaption').each(function(){
      $(this).parents('.content-block').addClass('has-capt');
    });

    $('.content-block.type-duo').each(function(){
      if($(this).find('.duo--parent > ul:last-child').find('figcaption').length==0) {
        $(this).removeClass('has-capt');
      }
    });

    $('figcaption').each(function(){
      let h = $(this).outerHeight();
      // console.log(h);
      if(h>remToPx(3.25)){
        if($(this).parents('.duo--parent').length==0) {
          $(this).parents('.content-block').addClass('more-margin-bot').css({
            'margin-bottom' : h + remToPx(2)
          });
        } else {
          if(MOBILE) {
            $(this).parents('ul').first().addClass('more-margin-bot').css({
              'margin-bottom' : h + remToPx(2)
            });
          }
        }
      }
    });
  }

  leave() {
    for(var i=0; i<window['projectanims'].length; i++){
      window.clearInterval(window.projectanims[i]);
    }
  }

  // initSlides(){
  // }
}

export default project;
